import { all, call, put, takeEvery } from 'redux-saga/effects'

import { LOGIN_SUCCESS } from '@app/modules/Auth/constants'
import { resolveAuthToken } from '@app/modules/Auth/resolveAuthToken'
import SDK from '@app/SDK'

import { FeatureState } from '../models'
import { Feature } from '../Services/models'

import FeatureActions from './actions'
import { FeatureActionTypes } from './actionTypes'

export class FeaturesSagas {
  public static *getFeatures() {
    try {
      const token = yield call(resolveAuthToken)
      const defaultFeatures = yield SDK.serviceManager.defaultFeatures()
      let userGroupFeatures = []
      if (token) {
        userGroupFeatures = yield SDK.serviceManager.userGroupFeatures(token)
      }
      const features: Feature[] = [...userGroupFeatures, ...defaultFeatures]
      const flags: FeatureState['features'] = features.reduce(
        (res, feature) => ({ ...res, [feature.name]: feature.enabled }),
        {}
      )
      yield put(FeatureActions.getFeaturesSuccess(flags))
    } catch (error) {
      yield put(FeatureActions.getFeaturesError(error))
    }
  }

  public static *run() {
    yield all([
      takeEvery(LOGIN_SUCCESS, FeaturesSagas.getFeatures),
      takeEvery(FeatureActionTypes.GET_FEATURES, FeaturesSagas.getFeatures)
    ])
  }
}
